export { useHorizontalNavMenuHeaderGroup as default };
import * as vue_composition_api from '@vue/composition-api';
import core_layouts_utils from '@core/layouts/utils';


function useHorizontalNavMenuHeaderGroup(item) {
  // ------------------------------------------------
  // isActive
  // ------------------------------------------------
  const isActive = vue_composition_api.ref(false);
  const updateIsActive = () => {
    isActive.value = core_layouts_utils.isNavLinkActive(item);
  };
  return {
    isActive,
    updateIsActive
  };
}

